import LuckyDrawParticipantTable from "./luckyDrawParticipantTable.container";

export default LuckyDrawParticipantTable;
